import getPageName from "../getPageName";
import formLock from "./formLock";

/* Модальное окно об отсутствии программ на странице программ */
function modalMissProgProgram(arr, region, arrStatus, level) {
  let shortUrl = location.href.split("/"),
    regionsArr = [],
    allProgramsRegionFiltred = [],
    firstArr,
    secondArr;

  /* Если не сайт программы, прекращаем выполнение функции */
  if (!shortUrl.includes("program")) {
    return;
  }

  if (region) {
    /* Фильтрация общего массива по выбранному региону */
    allProgramsRegionFiltred = arr.filter((item) =>
      item.regions.some((it) => it.region_id == region)
    );

    /* Удаляем дубли в отфильтрованном массиве */
    let allProgramsNoDublicate = allProgramsRegionFiltred.filter(
      (item, idx, arr) => {
        return (
          arr.findLastIndex((it) => it.shortname === item.shortname) === idx
        );
      }
    );

    /* Фильтруем общий массив по shortname */
    let filterProgramsByshortname = arr.filter(
      (it) => it.shortname == getPageName()
    );

    /* Деструктуризируем отфильтрованный массив в переменную */
    if (filterProgramsByshortname.length > 1) {
      [firstArr, secondArr] = filterProgramsByshortname;
      regionsArr = firstArr.regions.concat(secondArr.regions);
    } else if (filterProgramsByshortname.length == 1) {
      [firstArr] = filterProgramsByshortname;
      regionsArr = firstArr.regions;
    }

    /* Проверяем есть ли в массиве выбранный регион */
    let findRedionId = regionsArr
      .map((it) => it.region_id)
      .find((it) => it == region);

    if (
      findRedionId === undefined ||
      (arrStatus[0] == true &&
        arrStatus[1] == false)
    ) {
      if (allProgramsNoDublicate.length == 0) {
        createModal("1");
        formLock("lock");
      } else if (arrStatus[0] == true && arrStatus[1] == false) {
        createModal("2");
        formLock("lock");
      } else {
        /* Дополнительная проверка на уровень образования, чтобы не отображать на уровень ПО программы ДПО */
        const programsPO = allProgramsNoDublicate.filter(item => item.level == "vocational");

        if (level == "1" && programsPO.length < 1) {
          createModal("2");
        } else if (level == "1" && programsPO.length > 0) {
          createModal("3", programsPO);
        } else {
          createModal("3", allProgramsNoDublicate);
        }       
        
        formLock("unlock");
      }
    } else {
      formLock("unlock");
    }

    /* Создание модального окна с доступными программами в регионе */
    function createModal(status, programs) {
      const a = document.createElement("a");
      a.href = "#ProgramsModal";
      a.rel = "modal:open";
      a.style.display = "none";
      document.body.append(a);

      let modalRegions = document.querySelector("#ProgramsModal");

      if (modalRegions) {
        modalRegions.remove();
      }

      let modal = document.createElement("div");
      ["modal", "modal-programs"].forEach((additionalClass) => {
        modal.classList.add(additionalClass);
      });

      modal.id = "ProgramsModal";

      if (status == "1") {
        modal.innerHTML = `<div class="modal-programs__content">
        <h3>К сожалению, в вашем регионе программы не&nbsp;реализуются</h3>
      </div>`;
        document.body.append(modal);
      } else if (status == "2") {
        modal.innerHTML = `<div class="modal-programs__content">
        <h3>К сожалению, по данному уровню образования программа не&nbsp;доступна</h3>
      </div>`;
        document.body.append(modal);
      } else {
        modal.innerHTML = `<div class="modal-programs__content">
        <h3>К сожалению, в вашем регионе программа не реализуется</h3>
        <p>Но вы все еще можете пройти <strong>бесплатное обучение</strong> и получить помощь в старте карьеры по другим программам. Вот какие программы доступны в вашем регионе:</p>
        <div class="modal-programs__links"></div>
      </div>`;
        document.body.append(modal);

        programs.forEach((item) => {
          document.querySelector(".modal-programs__links").innerHTML += `
            <a href="/program/${item.shortname}" target="_blank">${item.name}</a>
          `;
        });
      }

      a.click();
      a.remove();
    }
  }
}

export default modalMissProgProgram;
